import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

// Print out API environment variables
const apiBaseUrl = environment.apiBaseUrl;

console.info('API url: ', {
  apiBaseUrl,
});

console.info('API url for PDF: ', {
  apiBaseUrlForPDF: environment.apiBaseUrlForPDF,
});

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
